import React, {useEffect,useState} from 'react';
import {FormValidator, useFormValidator, Inputs, TextArea} from 'coaz-ui';
import client from '../client';

const AddCpdStudent = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const cpdId = params ? params.cpdId : null;
	const [user,setUser] = useState(null);
    const [cpd,setCpd] = useState(null);
	const [teacher,setTeacher] = useState([]);
	const [teachers,setTeachers] = useState([]);
    const minWidth = 240;
    const {request,getCurrent,errorMessage} = client;

    const submit = async (e) => {
		if(!user || !cpd || !teacher) return {
			message: " missing fields!"
		};

        try {
            const response = await request('POST', 'cpd-students',null, {
				cpdId:cpdId, 
				userReference:user.ref.value,
				programId: cpd.program.ref.id,
				teacherReference: teacher.user.ref.value
			});

            if (response) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            console.log(error.response && error.response.data);
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const onTeacher = (e) => {
        const value = e.target.value;
        
		let found = teachers.find((teacher) => {return teacher.user.id == value});

		if(found) {
			setTeacher(found);
		} else {
			setTeacher(null);
		}
    };

    const inputs = [
        {
            label:'Cpd',
            type:'text', 
            name:'cpd',
            value:cpd?.name ?? '', 
            disabled:true
        },
        {
            label:'Teacher',
            type:'select',
            options:() => {
                let options = [];
                teachers && teachers.map((option,i) => options.push(<option key={i} value={option?.user?.ref?.value}>{option?.user?.name}</option>));
                return options;
            },
            name:'teacher', 
            value:teacher?.user?.name ?? '',
            onChange:(e) => handleChange(e,onTeacher),
			register:register,
            checks:['empty'],
            errors:errors
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        (async () => {
            setLoading && setLoading(true);

			let current = null;

			try {
				current = await getCurrent();
			} catch (error) {
				console.log(error);
				return;
			}

			if (!current && !current.user) return;

			setUser(current.user);

            try {
                const response = await request('GET', `cpds/${cpdId}`,null,{bypassReservedCheck:true});
                if (response && response.ref) {
                    setCpd(response);
                }
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await request('GET', 'teachers/by-cpd', null, {cpdId:cpdId});
                if (response && response.length > 0) {
                    setTeachers(response);
                    setTeacher(response[0]);
                } else {
                    setTeachers([]);
                }
            } catch (error) {
                console.log(error);
            }

            setLoading && setLoading(false);
        })();
    }, [cpdId]);

    return (
        <FormValidator>
			<Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
        </FormValidator>
      )
}

export default AddCpdStudent